module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921055649_T.d97c5ac9.jpg";